import { i18n } from "@lingui/core"

import { Locale, LOCALES } from "../utils/locales"

export interface LocalizedPageContext {
  locale: Locale
  commonCatalog: Dictionary<string>
  pageCatalog: Dictionary<string>
}

const emptyCatalogInitialState = LOCALES.reduce(
  (acc, locale) => {
    acc[locale] = {}
    return acc
  },
  {} as Record<Locale, Dictionary<string>>,
)

i18n.load(emptyCatalogInitialState)

export { i18n }

/**
 * Determine the page namespace from the pathname
 * Supports nested paths like /catalog/apple-gift-cards/
 */
export function getPageNamespace(pathname: string): string {
  // Remove leading and trailing slashes and split by /
  const parts = pathname.replace(/^\/|\/$/g, "").split("/")

  // Check if first part is a locale code
  if (parts[0] && /^[a-z]{2}$/.test(parts[0])) {
    // Remove locale part
    parts.shift()
  }

  // If there are no parts left, it's the root path (currently unused)
  if (parts.length === 0 || parts[0] === "") {
    return "__root_path__"
  }

  // For nested paths, just return the top-level directory or path
  // Ex: "/catalog/apple-gift-cards/" → "catalog"
  // Ex: "/de/catalog/apple-gift-cards/" → "catalog"
  const namespace = parts[0]

  // Silly special case where a page reaches into an unexpected
  // directory for most of its content, breaking the namespace convention.
  // I cannot rename the directory because we also have a /catalog/ page.
  if (namespace === "recipient-catalog") {
    return "catalog"
  }

  return namespace
}
